import React from "react"
import {footerText} from "../utils/config"

const Footer = ({}) => {
  return <div className="footer">
    <div>{footerText}</div>
    <a href="https://beian.miit.gov.cn" target="_blank"> 沪ICP备10031748号-19 </a>
    <div>沪公网安备 31000099763-22003</div>
  </div>
}

export default Footer
